import { render, staticRenderFns } from "./findCategory.vue?vue&type=template&id=952514ba"
import script from "./findCategory.vue?vue&type=script&lang=js"
export * from "./findCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports